// extracted by mini-css-extract-plugin
export default {"cardsGrid":"BuyPackageModal-module__cardsGrid--pcqCY","stateRow":"BuyPackageModal-module__stateRow--aTLjC","stateText":"BuyPackageModal-module__stateText--IqdK8"};